import React from 'react';
import { FiMail, FiMapPin, FiPhone } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { getSiteConfig } from '../../utils/siteConfig';

const PhoneIcon = FiPhone as React.ComponentType<{ className?: string }>;
const MailIcon = FiMail as React.ComponentType<{ className?: string }>;
const MapIcon = FiMapPin as React.ComponentType<{ className?: string }>;

const ContactInfoCards: React.FC = () => {
  const { t } = useTranslation();
  const siteConfig = getSiteConfig();

  return (
    <aside className="space-y-4">
      <section className="bg-white rounded-xl p-6 border border-[#E2E8F0]">
        <h3 className="font-bold text-[#0F172A] text-sm mb-4">{t('contactSection.info.contactInformationTitle')}</h3>
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center bg-[#eef6f6] text-[#0ca8a2]">
              <PhoneIcon className="h-5 w-5" />
            </span>
            <div className="space-y-2 pt-2 text-sm text-[#64748B]">
              {siteConfig.phoneNumbers.map((phoneNumber) => (
                <a
                  key={`${siteConfig.key}-phone-${phoneNumber}`}
                  href={`tel:${phoneNumber.replace(/\s+/g, '')}`}
                  className="block hover:text-teal-600 transition-colors"
                >
                  {phoneNumber}
                </a>
              ))}
            </div>
          </li>
          <li className="flex items-start gap-3">
            <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center bg-[#eef6f6] text-[#0ca8a2]">
              <MailIcon className="h-5 w-5" />
            </span>
            <div className="space-y-2 pt-2 text-sm text-[#64748B]">
              {siteConfig.emails.map((emailAddress) => (
                <a
                  key={`${siteConfig.key}-email-${emailAddress}`}
                  href={`mailto:${emailAddress}`}
                  className="block break-all hover:text-teal-600 transition-colors"
                >
                  {emailAddress}
                </a>
              ))}
            </div>
          </li>
        </ul>
      </section>

      <section className="bg-white rounded-xl p-6 border border-[#E2E8F0]">
        <h3 className="font-bold text-[#0F172A] text-sm mb-4">{t('contactSection.info.ourOfficesTitle')}</h3>
        <ul className="space-y-4 text-sm text-[#64748B]">
          {siteConfig.offices.map((office) => (
            <li key={`${siteConfig.key}-${office.city}`} className="flex items-start gap-3">
              <span className="w-10 h-10 rounded-lg bg-teal-50 flex items-center justify-center shrink-0 text-[#0ca8a2]">
                <MapIcon className="h-4 w-4" />
              </span>
              <div>
                <p className="font-semibold text-[#0F172A]">{office.city}</p>
                <p>{office.address}</p>
              </div>
            </li>
          ))}
        </ul>
      </section>

      <section className="bg-[#0A1628] rounded-xl p-6 text-white">
        <h3 className="font-bold text-sm mb-2">{t('contactSection.info.experienceCenterTitle')}</h3>
        <p className="text-white/50 text-sm font-light">{siteConfig.experienceCenterDescription}</p>
      </section>
    </aside>
  );
};

export default ContactInfoCards;
